import { safeDecodeURIComponent } from "../../common/helpers/string.util";
import { Paths, buildPath } from "../../common/paths/paths";

const ITO_ORDER_ID_PREFIX = "ito::";

/** The amznham tracking path for an `/orders#<ITO order ID>` notification link, or undefined when the hash holds no ITO order ID. */
export const amznhamTrackingPathForHash = (hash: string): string | undefined => {
  const orderId = safeDecodeURIComponent(hash.replace(/^#/, ""));
  if (!orderId.startsWith(ITO_ORDER_ID_PREFIX)) {
    return undefined;
  }
  return buildPath(Paths.amznhamOrderTracking.url, { orderId });
};
